module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "cc-status collapse in",
    attrs: {
      "id": "collapseStatus"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAcd),
      expression: "isAcd"
    }]
  }, [_vm._v("ACD: " + _vm._s(_vm.acdText) + "(" + _vm._s(_vm.login.acdKey) + ") - ")]), _vm._v("\n        Callcenter: " + _vm._s(_vm.login.companyCallCenter.name) + " - Agent:: " + _vm._s(_vm.login.userCallCenter.firstName) + "  " + _vm._s(_vm.login.userCallCenter.lastName) + " \n        "), _c('span', {
    staticClass: "small",
    attrs: {
      "title": _vm.config_path
    }
  }, [_vm._v("(" + _vm._s(_vm.aclText) + ")")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button",
      "title": "logout"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('logout')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-log-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('span', {
    staticClass: "text-center"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cb9fdbd6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Status.vue
// module id = 290
// module chunks = 0